import { render } from "./PrivacyPolicy.vue?vue&type=template&id=12aeb6f8&scoped=true"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js"

import "@/assets/css/topics.sass?vue&type=style&index=0&id=12aeb6f8&lang=sass&scoped=true"
import "./PrivacyPolicy.vue?vue&type=style&index=1&id=12aeb6f8&scoped=true&lang=css"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12aeb6f8"]])

export default __exports__